export default __webpack_public_path__ + "static/media/img_11.a07a458c.webp";